import { LayerGraph, LayerNode } from "../../framework/layer/LayerGraph";
import { GameContext } from "../common/GameContext";
import { LobbyDataListener, LobbyDataProvider } from "../common/LobbyDataLayers";
import { ReplicatedObjectDataListener, ReplicatedObjectDataProvider, ReplicatedObjectViewMapper } from "../common/ReplicatedObjectDataLayers";
import { ClientPlayerAndGameIdProvider, UserDataListener, UserDataProvider } from "../common/UserDataLayers";
import { ActionClient } from "./ActionClient";
import { ActionResultDataListener } from "./ActionResultDataListener";
import { ActionResultDeleter } from "./ActionResultDeleter";
import { GameContextListener } from "./GameContextListener";
import { LoginLayer, UserIdProvider } from "./LoginLayer";
import { ReplicatedActionCreator } from "./ReplicatedActionCreator";
import { SetTestingModeLayer } from "./SetTestingModeLayer";
export class ClientGame {
    constructor() {
        this.firebase = null;
        this.deleteApp = null;
        this.layerGraph = null;
    }
    create(input) {
        const { gameContextListenerKeys, actionValidatorMap, replicatedObjectKeyMapping, replicatedObjectViewBuilderMap, requiredReplicatedObjectKeys, } = input.config;
        const { isTestingMode, testingModeIndex, username, desiredGame, firebase, deleteApp } = input.props;
        this.firebase = firebase;
        this.deleteApp = deleteApp;
        const loginLayer = new LoginLayer(firebase, isTestingMode, testingModeIndex, username, desiredGame);
        const userIdProvider = new UserIdProvider(loginLayer);
        const userDataListener = new UserDataListener(firebase, userIdProvider);
        const userDataProvider = new UserDataProvider(userDataListener);
        const playerAndGameIdProvider = new ClientPlayerAndGameIdProvider(userDataProvider);
        const setTestingModeLayer = new SetTestingModeLayer(firebase, playerAndGameIdProvider, isTestingMode, testingModeIndex);
        const replicatedObjectDataListener = new ReplicatedObjectDataListener(firebase, playerAndGameIdProvider, replicatedObjectKeyMapping);
        const replicatedObjectViewMapper = new ReplicatedObjectViewMapper(replicatedObjectViewBuilderMap, playerAndGameIdProvider, replicatedObjectDataListener);
        const replicatedObjectDataProvider = new ReplicatedObjectDataProvider(replicatedObjectViewMapper, requiredReplicatedObjectKeys);
        const lobbyDataListener = new LobbyDataListener(firebase, playerAndGameIdProvider);
        const lobbyDataProvider = new LobbyDataProvider(lobbyDataListener);
        const gameContext = new GameContext({
            playerAndGameIdProvider,
            lobbyDataProvider,
            replicatedObjectDataProvider,
        });
        const gameContextListener = new GameContextListener(gameContext, gameContextListenerKeys);
        const actionResultDataListener = new ActionResultDataListener(firebase, playerAndGameIdProvider);
        const replicatedActionCreator = new ReplicatedActionCreator(firebase, playerAndGameIdProvider);
        const actionResultDeleter = new ActionResultDeleter(firebase, playerAndGameIdProvider);
        const actionClient = new ActionClient(gameContext, replicatedActionCreator, actionResultDeleter, actionValidatorMap);
        const loginLayerNode = new LayerNode(loginLayer, []);
        const userIdProviderNode = new LayerNode(userIdProvider, [loginLayerNode]);
        const userDataListenerNode = new LayerNode(userDataListener, [userIdProviderNode]);
        const userDataProviderNode = new LayerNode(userDataProvider, [userDataListenerNode]);
        const playerAndGameIdProviderNode = new LayerNode(playerAndGameIdProvider, [userDataProviderNode]);
        const setTestingModeLayerNode = new LayerNode(setTestingModeLayer, [playerAndGameIdProviderNode]);
        const replicatedObjectDataListenerNode = new LayerNode(replicatedObjectDataListener, [playerAndGameIdProviderNode]);
        const replicatedObjectViewMapperNode = new LayerNode(replicatedObjectViewMapper, [replicatedObjectDataListenerNode]);
        const replicatedObjectDataProviderNode = new LayerNode(replicatedObjectDataProvider, [replicatedObjectViewMapperNode]);
        const lobbyDataListenerNode = new LayerNode(lobbyDataListener, [playerAndGameIdProviderNode]);
        const lobbyDataProviderNode = new LayerNode(lobbyDataProvider, [lobbyDataListenerNode]);
        const gameContextNode = new LayerNode(gameContext, [replicatedObjectDataProviderNode, playerAndGameIdProviderNode, lobbyDataProviderNode]);
        const gameContextListenerNode = new LayerNode(gameContextListener, [replicatedObjectDataProviderNode, playerAndGameIdProviderNode, lobbyDataProviderNode, gameContextNode]);
        const actionResultDataListenerNode = new LayerNode(actionResultDataListener, [playerAndGameIdProviderNode]);
        const replicatedActionCreatorNode = new LayerNode(replicatedActionCreator, [playerAndGameIdProviderNode]);
        const actionResultDeleterNode = new LayerNode(actionResultDeleter, [playerAndGameIdProviderNode]);
        const actionClientNode = new LayerNode(actionClient, [actionResultDataListenerNode, gameContextNode, replicatedActionCreatorNode, actionResultDeleterNode]);
        const layerGraph = new LayerGraph([loginLayerNode]);
        this.layerGraph = layerGraph;
        return {
            layerGraph,
            gameContextListener,
            replicatedActionClient: actionClient,
        };
    }
    stop() {
        this.deleteApp();
        this.firebase.close();
    }
}
//# sourceMappingURL=ClientGame.js.map